import React, { Component } from 'react'
import {
  extendParentClass,
  extendBaseClass,
  extend,
} from '../../../utils/classes'
import Trial from '../../shared/Trial'

export class Slide extends Component {
  baseClass = extendParentClass.bind(this)('slide')

  extend = extendBaseClass.bind(this)

  render() {
    const bodyClass = this.extend('body')
    const { title, Image, description } = this.props
    const imageCol = this.extend('image-col')
    return (
      <div className={this.baseClass}>
        <div className={imageCol}>
          <Image className={extend(imageCol, 'image')} />
        </div>
        <div className={bodyClass}>
          <h3 className={extend(bodyClass, 'title')}>{title}</h3>
          <p className={extend(bodyClass, 'description')}>{description}</p>
          <Trial parentClass={bodyClass} />
        </div>
      </div>
    )
  }
}

export default Slide
